import { InsuranceJourneyState } from '../../components/common/CommonTypes';
import { Source } from '../../components/common/Constants';
import ActionTypes from './ActionTypes';

const InsuranceJourneyReducer = (
  state: InsuranceJourneyState,
  action: ActionTypes
): InsuranceJourneyState => {
  switch (action.type) {
    case 'set-quote':
      return { ...action.quote };

    case 'set-personal-details':
      return {
        ...state,
        personalDetails: action.personalDetails
      };

    case 'set-driving-history-details':
      return {
        ...state,
        drivingHistoryDetails: action.drivingHistoryDetails
      };

    case 'set-vehicle-details':
      return {
        ...state,
        vehicleInfo: action.vehicleInfo
      };

    case 'set-cover-details':
      return {
        ...state,
        coverDetails: action.coverDetails
      };

    case 'set-address-details':
      return {
        ...state,
        addressDetails: action.addressDetails
      };

    case 'set-additionl-driver-details':
      return {
        ...state,
        additionalDriverDetails: action.additionalDriverDetails
      };

    case 'set-confirmation-details':
      return {
        ...state,
        confirmationDetails: action.confirmationDetails
      };

    case 'set-your-quote-details':
    case 'set-optional-cover-details':
      return {
        ...state,
        insuranceProducts: action.insuranceProducts
      };

    case 'set-customer-self-registration':
      return {
        ...state,
        source: Source.CustomerSelfRegistration,
        vehicleInfo: {
          ...state.vehicleInfo,
          vendor: action.vendor,
          dealer: action.dealer
        },
        dealerHomeOptions: action.dealerHomeOptions
      };

    case 'set-saving-quote':
      return {
        ...state,
        savingQuote: action.savingQuote
      };

    case 'set-page-loading':
      return {
        ...state,
        pageLoading: action.pageLoading
      };

    case 'set-nav-status':
      return {
        ...state,
        insuranceNavigationStatus: {
          ...state.insuranceNavigationStatus,
          [action.key]: action.value
        }
      };

    case 'set-about-terms-of-business-and-fair-use-details':
      return {
        ...state,
        aboutTermsOfBusinessAndFairUseDetails:
          action.aboutTermsOfBusinessAndFairUseDetails
      };

    case 'set-important-notice-information-details':
      return {
        ...state,
        importantNoticeInformationDetails:
          action.importantNoticeInformationDetails
      };

    case 'set-payment-details':
      return {
        ...state,
        paymentDetails: action.paymentDetails
      };

    case 'set-payment-method':
      return {
        ...state,
        paymentDetails: {
          ...state.paymentDetails,
          selectedPaymentMethod: action.paymentMethod
        }
      };

    case 'set-static-data':
      return {
        ...state,
        staticData: action.staticData
      };

    case 'set-dealer-home-page-options':
      return {
        ...state,
        dealerHomeOptions: action.dealerHomepageOptions
      };

    case 'set-dealer-username':
      return {
        ...state,
        dealerUsername: action.dealerUsername
      };

    case 'set-dealer-representative':
      return {
        ...state,
        dealerRepresentative: action.dealerRepresentative
      };

    default:
      return state;
  }
};

export default InsuranceJourneyReducer;
